export default {
  referToFriend: "Referir a un amigo(a)",
  aboutMe: "Sobre mí",
};
